<template>
	<div class="container-fluid content">
    <div class="row">
      <div class="col-md-12">
        <h4>{{ $t('Mi pedido') }}</h4>
        
        <pasos-compra></pasos-compra>  

        <br><br><br> 

        <pedido tipo="cine"></pedido>

      </div>
    </div>
  </div>
</template>

<i18n>
{
  "es": {
    "Mi pedido": "Mi pedido"
  },
  "en": {
  },
  "ca": {
    "Mi pedido": "La meva comanda"
  }
}
</i18n>

<script>
  import axios from 'axios';

  import UsuarioEditarPerfil from './UsuarioEditarPerfil.vue';
  import UsuarioCambiarContrasena from './UsuarioCambiarContrasena.vue';
  import PasosCompra from './usuario/PasosCompra.vue';
  import Seleccion from './usuario/Seleccion.vue';
  import SeleccionTotales from './usuario/SeleccionTotales.vue';
  import Pedido from './usuario/Pedido.vue';

	export default {
    components: { PasosCompra, Pedido},
    data: () => {
      return {
      }
    },
    created(){
    },
    mounted(){
    },
    updated(){
    },
    computed: {},
    methods:{
    }
  }
</script>
